import React, { Component } from 'react';
import Swipe from 'react-swipe-component';

const images = [
    "desktop/Img_Palms.png",
    "desktop/Img_Lips.png",
    "desktop/Img_Cheeks1.png",
    "desktop/Img_Elbow1.png",
    "desktop/Img_Feet.png"
]
class GameNode extends Component {
    constructor() {
        super();
        this.state = {
            isActive: false,
            goToItem: null,
            svgRight: "227",
            svgLeft: "144",
            isLoading: true,
            sendPush: false,
            sent: 1
        }
        this.onSwipeLeftListener = this._onSwipeLeftListener.bind(this);
        this.onSwipeRightListener = this._onSwipeRightListener.bind(this);
        this.onSwipeDownListener = this._onSwipeUpListener.bind(this);
        this.onSwipeUpListener = this._onSwipeDownListener.bind(this);
        this.onSwipeListener = this._onSwipeListener.bind(this);
        //this.goToNext = this.goToNext.bind(this);
    }
    isMobile() {
        if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        } else {
            return false;
        }
    }
    preloadImages(urls) {
        let totalImages = urls.length - 1;
        let count = 0;
        urls.forEach(url => {
            let image = new Image();
            image.onload = () => {
                if (++count === totalImages) {
                    this.setState({
                        isLoading: false
                    });
                }
            }
            image.src = `./static/images/${url}`;
        })
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            goToItem: nextProps.goToItem
        })
    }
    componentDidMount() {
        this.preloadImages(images);
        this.setState({
            svgRight: this.props.gameNode.svgRight,
            svgLeft: this.props.gameNode.svgLeft
        });
    }
    _onSwipeLeftListener(e) {
        /*
        //
            console.log("Swiped left");
        */
    }
    _onSwipeRightListener() {
        //console.log("Swiped right");
    }
    _onSwipeUpListener() {
        //window.scrollTo(0, window.scrollY-30)
    }
    _onSwipeDownListener() {
        //window.scrollTo(0, window.scrollY+30)
    }
    _onSwipeListener(e) {
    //    if (e[1] === 0) console.log("Swipe x: " + e[0]);
     //   else if (e[0] === 0) console.log("Swipe y: " + e[1]);
        switch (this.props.gameNode.className) {
            case "feet":
                if (e[0] <= 0) {
                    this.setState({
                        svgRight: (e[0] * -1 / 4 >= 140 ? 140 : Math.round(227 - e[0] * -1 / 4)),
                        svgLeft: (e[0] * -1 / 4 >= 140 ? 69 : Math.round(144 - e[0] * -1 / 4))
                    })
                    // if (e[0] * -1 / 2 >= 60) {
                    //     this.goToNext();
                    // }
                    window.setTimeout(() => {
                        this.goToNext();
                    }, 250);
                }
                break;
            case "cheecks":
                if (e[0] <= 0) {
                    this.setState({
                        svgRight: (e[0] * -1 / 4 >= 140 ? 140 : Math.round(227 - e[0] * -1 / 4)),
                        svgLeft: (e[0] * -1 / 4 >= 140 ? 69 : Math.round(144 - e[0] * -1 / 4))
                    })
                    // if (e[0] * -1 / 2 >= 60) {
                    //     this.goToNext();
                    // }
                    window.setTimeout(() => {
                        this.goToNext();
                    }, 250);
                }
                break;
            case "elbow":
                if (e[0] <= 0) {
                    var xY = (e[0] < 0 ? e[0] * -1 : e[0]);
                    this.setState({
                        svgRight: (this.props.gameNode.svgRight_max + xY > 0 ? 0 : Math.round(this.props.gameNode.svgRight_max + xY)),
                        svgLeft: (e[0] * -1 / 4 >= this.props.gameNode.svgLeft_max ? 25 : Math.round(this.props.svgLeft_max + e[0] * -1 / 4))
                    })
                    // if (xY / 2 >= 30) {
                    //     this.goToNext();
                    // }
                    window.setTimeout(() => {
                        this.goToNext();
                    }, 250);
                }
                break;
            case "palms":
                if (e[0] <= 0) {
                    var xY = (e[0] < 0 ? e[0] * -1 : e[0]);
                    this.setState({
                        svgRight: (this.props.gameNode.svgRight_max + xY > 0 ? 0 : Math.round(this.props.gameNode.svgRight_max + xY)),
                        svgLeft: (e[0] * -1 / 4 >= this.props.gameNode.svgLeft_max ? 25 : Math.round(this.props.svgLeft_max + e[0] * -1 / 4))
                    })
                    // if (xY / 2 >= 30) {
                    //     this.goToNext();
                    // }
                    window.setTimeout(() => {
                        this.goToNext();
                    }, 250);
                }
                break;
            case "lips":
                if (e[0] <= 0) {
                    var xY = (e[0] < 0 ? e[0] * -1 : e[0]);
                    this.setState({
                        svgRight: (this.props.gameNode.svgRight_max + xY > 0 ? 0 : Math.round(this.props.gameNode.svgRight_max + xY)),
                        svgLeft: (e[0] * -1 / 4 >= this.props.gameNode.svgLeft_max ? 25 : Math.round(this.props.svgLeft_max + e[0] * -1 / 4))
                    })
                    // if (xY / 2 >= 30) {
                    //     this.goToNext();
                    // }
                    window.setTimeout(() => {
                        this.goToNext();
                    }, 250);
                }
                break;
        }
    }
    goToNext() {
        window.setTimeout(() => {
            this.setState({
                isActive: true,
                svgRight: this.props.gameNode.svgRight,
                svgLeft: this.props.gameNode.svgLeft
            })
            window.setTimeout(() => {
                var element = document.getElementById(this.props.gameNode.className + "_tips");
                element.scrollIntoView();
                element.scrollIntoView(false);
                element.scrollIntoView({ block: "end" });
                element.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });
            }, 250);
        }, 250);

        window.setTimeout(() => {
            this.props.nextItemIs(Math.round(this.props.index + 1));
            this.setState({
                isActive: false
            })
        }, 6000);

        if(!this.state.sendPush && this.state.sent == 1)    {
            this.props._dataLayer(this.props.gameNode.className);
            this.setState({
                sendPush: true,
                sent: 2
            })
            window.setTimeout(() => {
                this.setState({
                    sendPush: false,
                    sent: 1
                })
            }, 2000);
        }
    }
    getTips() {
        return this.props.gameNode.tips.map((tip, index) => <Tiplist key={index} name={tip.name} desc={tip.desc} />)
    }
    render() {
        return (
            <div className={`game ${this.props.gameNode.className}${(this.state.isActive ? " active" : "")}`} style={{ display: (this.state.goToItem == this.props.index ? "block" : (this.state.goToItem == null ? (this.props.index == 0 ? "block" : "none") : "none")) }}>
{/* כיף */}
                <div className="image"></div>
                <Swipe
                    nodeName="div"
                    className="swipe1"
                    mouseSwipe={true}
                    onSwipedLeft={this.onSwipeLeftListener}
                    onSwipedRight={this.onSwipeRightListener}
                    onSwipedDown={this.onSwipeDownListener}
                    onSwipedUp={this.onSwipeUpListener}
                    onSwipe={this.onSwipeListener}>
                    <div className="headline">
                        <div className="head">
                            {this.props.gameNode.headline}
                        </div>
                    </div></Swipe>
                <Overlay
                    state={this.state}
                    node={this.props.gameNode}
                    onSwipeLeftListener={this.onSwipeLeftListener}
                    onSwipeRightListener={this.onSwipeRightListener}
                    onSwipeDownListener={this.onSwipeDownListener}
                    onSwipeUpListener={this.onSwipeUpListener}
                    onSwipeListener={this.onSwipeListener} />
                <div className="tips" id={`${this.props.gameNode.className}_tips`}>
                    <div className="container">
                        <div className="silsul">
                            <div className="sil up"></div>
                            <div className="sil center"></div>
                            <div className="sil down"></div>
                        </div>
                        <div className="tiplist">
                            {this.getTips()}
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
const Overlay = (props) => {
    switch (props.node.className) {
        default:
            return null;
            break;
        case "feet":
            return (
                <div className="overlays">
                    <div className="overlay_before"></div>
                    <Swipe
                        nodeName="div"
                        className="overlay_after"
                        mouseSwipe={true}
                        onSwipedLeft={props.onSwipeLeftListener}
                        onSwipedRight={props.onSwipeRightListener}
                        onSwipedDown={props.onSwipeDownListener}
                        onSwipedUp={props.onSwipeUpListener}
                        onSwipe={props.onSwipeListener}>
                        <div className="right">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 118.36 140.53">
                                <path style={{ strokeDashoffset: `${props.state.svgRight}px`, strokeDasharray: "74px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M117,84.4c2.06-7.85.54-10.54-6.48-14.67a23.54,23.54,0,0,0-9.27-3.39h0c-2.09-1.15-4.16-1.52-6.13.26h0l1.07,2c.57,2.72,2.58,4,4.94,5h0c4.11,3.76,7,8.64,5.06,13.85s-5,10.59-10.4,13.77a92.75,92.75,0,0,0-8.58,6.32v0h0a34.22,34.22,0,0,0-3.79,1.06c-15.19,6.1-28.83" />
                            </svg>
                        </div>
                        <div className="left">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.73 99.8">
                                <path style={{ strokeDashoffset: `${props.state.svgLeft}px`, strokeDasharray: "93px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M75.07,61.38C72.37,36.61,49.9,2.88,23.06.87,22.69.85,22.35.3,22,0H11c-6,4.4-6.19,8.32-.1,12.06,4.92,3,10.72" />
                            </svg>
                        </div>
                    </Swipe>
                </div>)
            break;
        case "elbow":
            return (
                <div className="overlays">
                    <Swipe
                        nodeName="div"
                        className="overlay_before"
                        mouseSwipe={true}
                        onSwipedLeft={props.onSwipeLeftListener}
                        onSwipedRight={props.onSwipeRightListener}
                        onSwipedDown={props.onSwipeDownListener}
                        onSwipedUp={props.onSwipeUpListener}
                        onSwipe={props.onSwipeListener}>
                        <div className="overlay_after">
                            <div className="right">
                                <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 118.36 140.53">
                                    <path style={{ strokeDashoffset: `${props.state.svgRight}px`, strokeDasharray: "74px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M117,84.4c2.06-7.85.54-10.54-6.48-14.67a23.54,23.54,0,0,0-9.27-3.39h0c-2.09-1.15-4.16-1.52-6.13.26h0l1.07,2c.57,2.72,2.58,4,4.94,5h0c4.11,3.76,7,8.64,5.06,13.85s-5,10.59-10.4,13.77a92.75,92.75,0,0,0-8.58,6.32v0h0a34.22,34.22,0,0,0-3.79,1.06c-15.19,6.1-28.83" />
                                </svg>
                            </div>
                            <div className="left">
                                <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.73 99.8">
                                    <path style={{ strokeDashoffset: `${props.state.svgLeft}px`, strokeDasharray: "93px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M75.07,61.38C72.37,36.61,49.9,2.88,23.06.87,22.69.85,22.35.3,22,0H11c-6,4.4-6.19,8.32-.1,12.06,4.92,3,10.72" />
                                </svg>
                            </div>
                        </div>
                    </Swipe>
                </div>)
            break;
        case "palms":
            return (
                <div className="overlays">
                    <div className="overlay_before"></div>
                    <Swipe
                        nodeName="div"
                        className="overlay_after"
                        mouseSwipe={true}
                        onSwipedLeft={props.onSwipeLeftListener}
                        onSwipedRight={props.onSwipeRightListener}
                        onSwipedDown={props.onSwipeDownListener}
                        onSwipedUp={props.onSwipeUpListener}
                        onSwipe={props.onSwipeListener}>
                        <div className="right">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.25 42.5">
                                <path style={{ strokeDashoffset: `${props.state.svgRight}px`, strokeDasharray: "93px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M129.39,2.26h0c-12.36-1.18-24,8.61-23,21.6.32,4,.43,8,.51,12,.06,2.61.79,5.2-.17,7.84-3.42,9.41-12.7,14-22.06,10.89-8.78-3-12.28-11.2-8.84-21.18,1.62-4.71,3.86-9.24,5.16-14C84.54,6.28,75.8-2.5,62.63.64,50.82,3.45,44,12,43.51,24.25c-.23,6.13,1,12.34-1,18.36-3.18,9.64-6.69,10.53-13.56,3.31a58.07,58.07,0,0,1-5.32-6.59A124.79,124.79,0,0,1,9.31,12a65.74,65.74,0,0,0-3.8-8.11C4.76,2.5,3.78.61,1.76,1.27S0,4.05,0,5.59A37,37,0,0,0,1.94,16.33C6.07" />
                            </svg>
                        </div>
                        <div className="left">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.25 42.5">
                                <path style={{ strokeDashoffset: `${props.state.svgLeft}px`, strokeDasharray: "69px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M156.27,35a55.49,55.49,0,0,0-.87-6.43c-2.46-13.09-9-23.22-22.39-26.71C120.62-1.36,107.87.35,95.27,1.45c-1,.09-2.13.33-2.47,1.39C92.37,4.2,93.44,5,94.43,5.6a21.18,21.18,0,0" />
                            </svg>
                        </div>
                    </Swipe>
                </div>)
            break;
        case "lips":
            return (
                <div className="overlays">
                    <div className="overlay_before">
                        <div className="describe">חבר את הנקודות</div>
                    </div>
                    <Swipe
                        nodeName="div"
                        className="overlay_after"
                        mouseSwipe={true}
                        onSwipedLeft={props.onSwipeLeftListener}
                        onSwipedRight={props.onSwipeRightListener}
                        onSwipedDown={props.onSwipeDownListener}
                        onSwipedUp={props.onSwipeUpListener}
                        onSwipe={props.onSwipeListener}>
                        <div className="right">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.25 42.5">
                                <path style={{ strokeDashoffset: `${props.state.svgLeft}px`, strokeDasharray: "88px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M201.05,32.72c-.51-1-1.48-1.66-2.44-1.15-2.25,1.19-5,0-7.1,1.67h0c-4.64,0-9.15,1.26-13.9.7-21-2.5-37.52-13.47-52.86-26.89-2.63-2.3-4.68-6.34-7.57-7-3.61-.78-5.17,4.26-7.92,6.46-14.71,11.71-32,17.39-49.81,21.93-8.59,2.19-17.12,2.58-25.51-.58A120.29,120.29,0,0,1,9.46,15.63C6.85,13.89,3.39,10.17.9,13.34c-2.72,3.46,1.32,6.6,4,9,10,8.8,22.63,12.24" />
                            </svg>
                        </div>
                        <div className="left">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.25 42.5">
                                <path style={{ strokeDashoffset: `${props.state.svgRight}px`, strokeDasharray: "69px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M201.05,32.72c-.51-1-1.48-1.66-2.44-1.15-2.25,1.19-5,0-7.1,1.67h0c-4.64,0-9.15,1.26-13.9.7-21-2.5-37.52-13.47-52.86-26.89-2.63-2.3-4.68-6.34-7.57-7-3.61-.78-5.17,4.26-7.92,6.46-14.71,11.71-32,17.39-49.81,21.93-8.59,2.19-17.12,2.58-25.51-.58A120.29,120.29,0,0,1,9.46,15.63C6.85,13.89" />
                            </svg>
                        </div>
                    </Swipe>
                </div>)
            break;
        case "cheecks":
            return (
                <div className="overlays">
                    <div className="overlay_before">
                        <div className="describe">חבר את הנקודות</div>
                    </div>
                    <Swipe
                        nodeName="div"
                        className="overlay_after"
                        mouseSwipe={true}
                        onSwipedLeft={props.onSwipeLeftListener}
                        onSwipedRight={props.onSwipeRightListener}
                        onSwipedDown={props.onSwipeDownListener}
                        onSwipedUp={props.onSwipeUpListener}
                        onSwipe={props.onSwipeListener}>
                        <div className="right">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.25 42.5">
                                <path style={{ strokeDashoffset: `${props.state.svgRight}px`, strokeDasharray: "227px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M49.5,32.3c-2,0-4.08-.35-6,.09-9.23,2.13-17.34-2-25.71-4.45-3.89-1.14-6.62-4-6.77-8.38a8.86,8.86,0,0,1,6.47-9.13c8-2.6,16-5.78,24.49-6.51,2.46,0,4.92.17,7.37.07.71,0,2-.74,2-1A4.78,4.78,0,0,0" />
                            </svg>
                        </div>
                        <div className="left">
                            <svg cxmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.25 42.5">
                                <path style={{ strokeDashoffset: `${props.state.svgLeft}px`, strokeDasharray: "144px", stroke: "#ffa838", fill: "none", strokeWidth: 3, strokeLinecap: "round" }} d="M49.5,32.3c-2,0-4.08-.35-6,.09-9.23,2.13-17.34-2-25.71-4.45-3.89-1.14-6.62-4-6.77-8.38a8.86,8.86,0,0,1,6.47-9.13c8-2.6,16-5.78,24.49-6.51,2.46,0,4.92.17,7.37.07.71,0,2-.74,2-1A4.78,4.78,0,0,0" />
                            </svg>
                        </div>
                    </Swipe>
                </div>)
            break;
    }
}
const Tiplist = (props) => {
    return (
        <div className="tip">
            <span>{props.name}</span><br />
            {props.desc}
        </div>
    )
}
export default GameNode;



// WEBPACK FOOTER //
// ./src/Components/MouseGame/GameNode.js